import React, {useMemo} from 'react';
import classNames from 'classnames';
import {ErrorType} from '@mc/react-mapio';
import {useAppConfig} from '@mc/react-app-base';
import {Icon} from '@mc/ui-v4';
import {mcDropDown} from '@mc/react-ui-icons';
import './ErrorReporter.scss';
interface ErrorReporterProps {
    error: ErrorType;
    setToggleErrorDetail: (id: string) => void;
    toggleErrorDetail: string | null;
    alwaysExpanded?: boolean;
}

export const ErrorReporter: React.FC<ErrorReporterProps> = ({error, setToggleErrorDetail, toggleErrorDetail, alwaysExpanded}) => {
    const {serverContextPath} = useAppConfig();
    const isOpen = alwaysExpanded || toggleErrorDetail === error.id;
    const formattedUrl = useMemo(() => {
        if (!error.url) return null;
        return error.url.startsWith('http') ? error.url : `${serverContextPath}${error.url}`;
    }, [error.url, serverContextPath]);
    return (
        <div className={classNames('error-reporter-card', {open: isOpen})} key={error.id}>
            {alwaysExpanded ? (
                <div className="error-reporter-title">
                    <span className="error-reporter-heading">
                        <strong className="error-reporter-layer">{error.title}</strong>
                        <span className="error-status error-reporter-message">{error.message}</span>
                    </span>
                    {error.count > 1 && <span className="error-reporter-count">{error.count}&times;</span>}
                </div>
            ) : (
                <button className="error-reporter-title" aria-expanded={isOpen} onClick={() => setToggleErrorDetail(isOpen ? '' : error.id)}>
                    <span className="error-reporter-chevron">
                        <Icon icon={mcDropDown} />
                    </span>
                    <span className="error-reporter-heading">
                        <strong className="error-reporter-layer">{error.title}</strong>
                        <span className="error-status error-reporter-message">{error.message}</span>
                    </span>
                    {error.count > 1 && <span className="error-reporter-count">{error.count}&times;</span>}
                </button>
            )}
            {isOpen && (
                <div className="errorreporter-error-detail">
                    {error.layerId && (
                        <div className="errorreporter-row">
                            <strong>Vrstva:</strong>
                            <span className={'error-status'}>
                                {error.layerId} ({error.layerName})
                            </span>
                        </div>
                    )}
                    {error.proxyUrl && (
                        <div className="errorreporter-row errorreporter-url">
                            <strong>URL (proxy):</strong>
                            <span>
                                <a className={'error-status'} target="_blank" rel="noreferrer" href={error.proxyUrl}>
                                    {error.proxyUrl}
                                </a>
                            </span>
                        </div>
                    )}
                    {error.url && (
                        <div className="errorreporter-row errorreporter-url">
                            <strong>URL:</strong>
                            <span>
                                <a className={'error-status'} target="_blank" rel="noreferrer" href={formattedUrl}>
                                    {formattedUrl}
                                </a>
                            </span>
                        </div>
                    )}
                    {!!error.httpStatus && (
                        <div className="errorreporter-row">
                            <strong>Odpověď serveru:</strong>
                            <span className={'error-status'}>
                                {error.httpStatus} {error.httpStatusText}
                            </span>
                        </div>
                    )}
                    {error.message && (
                        <div className="errorreporter-row">
                            <strong>Chybová zpráva:</strong> <span className={'error-status'}>{error.message}</span>
                        </div>
                    )}
                    {error.detail && (
                        <div className="errorreporter-row">
                            <strong>Detail chyby:</strong> <span className={'error-status errorreporter-detail-text'}>{error.detail}</span>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};
